import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "admin-professional-list py-56" }
const _hoisted_2 = { class: "d-flex mb-56 justify-content-between" }
const _hoisted_3 = { class: "h4 text-primary mb-0" }
const _hoisted_4 = { class: "fw-normal" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add-ring me-8",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = { class: "d-flex mb-48" }
const _hoisted_7 = { class: "d-flex table-responsive" }
const _hoisted_8 = { class: "fit" }
const _hoisted_9 = {
  class: "fit text-center",
  colspan: "1"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  colspan: "222222",
  class: "empty-state py-8 px-12 text-center"
}
const _hoisted_12 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_13 = { class: "h5 title text-primary mb-48" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add-ring me-8",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = { class: "fit text-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-trash",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_17 = { class: "fw-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_the_admin_video_category_create = _resolveComponent("the-admin-video-category-create")!
  const _component_the_admin_video_category_destroy = _resolveComponent("the-admin-video-category-destroy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('Listado de')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Categorías vídeos').toLowerCase()), 1)
        ]),
        (_ctx.can('admin.video-category.store'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: {name: 'admin.video-category.store'},
              class: "btn btn-secondary btn-icon btn-sm",
              "aria-label": _ctx.$t('Nueva categoría')
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Nueva categoría')), 1)
              ]),
              _: 1
            }, 8, ["to", "aria-label"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_input, {
          id: "search",
          class: "me-8",
          placeholder: _ctx.$t('Buscar categoría'),
          value: _ctx.filters.search,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => {_ctx.filters.search = $event; _ctx.search()})
        }, null, 8, ["placeholder", "value"]),
        _createVNode(_component_v_button, {
          variant: "secondary",
          class: "btn-icon text-nowrap",
          "aria-label": _ctx.$t('Limpiar filtros'),
          onClick: _ctx.emptyFilters
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Limpiar filtros')), 1)
          ]),
          _: 1
        }, 8, ["aria-label", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_table, { class: "table-bordered" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table_header, null, {
              default: _withCtx(() => [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('ID')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Nombre')), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('Acciones')), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_table_body, null, {
              default: _withCtx(() => [
                (!_ctx.categories.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('No hay categorías')), 1),
                          (_ctx.can('admin.video-category.store'))
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: {name: 'admin.video-category.store'},
                                class: "btn btn-secondary btn-icon btn-sm",
                                "aria-label": _ctx.$t('Nueva categoría')
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_14,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Nueva categoría')), 1)
                                ]),
                                _: 1
                              }, 8, ["to", "aria-label"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: category.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(category.id), 1),
                    _createElementVNode("td", null, _toDisplayString(category.name), 1),
                    _createElementVNode("td", _hoisted_15, [
                      (_ctx.can('admin.video-category.store'))
                        ? (_openBlock(), _createBlock(_component_v_button, {
                            key: 0,
                            variant: "icon",
                            class: "btn-sm justify-content-center d-flex flex-column p-0",
                            onClick: ($event: any) => (_ctx.openProfessionalModal(category, 'the-admin-video-category-destroy'))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16,
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('Eliminar')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      (_ctx.categories.length > 0)
        ? (_openBlock(), _createBlock(_component_v_pagination, {
            key: 0,
            meta: _ctx.pagination?.meta,
            pagination: _ctx.pagination?.pagination,
            onPageChanged: _ctx.handlePageChangedEvent
          }, null, 8, ["meta", "pagination", "onPageChanged"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.modalToShow === 'the-admin-video-category-create')
      ? (_openBlock(), _createBlock(_component_the_admin_video_category_create, {
          key: 0,
          professional: _ctx.selectedCategory,
          onClosed: _cache[1] || (_cache[1] = ($event: any) => {_ctx.modalToShow = null; _ctx.selectedCategory = null;}),
          onProfessionalCreated: _ctx.loadCategories
        }, null, 8, ["professional", "onProfessionalCreated"]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-admin-video-category-destroy')
      ? (_openBlock(), _createBlock(_component_the_admin_video_category_destroy, {
          key: 1,
          category: _ctx.selectedCategory,
          onClosed: _cache[2] || (_cache[2] = ($event: any) => {_ctx.modalToShow = null; _ctx.selectedCategory = null;}),
          onProfessionalDestroyed: _ctx.loadCategories
        }, null, 8, ["category", "onProfessionalDestroyed"]))
      : _createCommentVNode("", true)
  ], 64))
}